/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Accessibility fix for Flickity carousels.
 *
 * Flickity sets aria-hidden="true" on non-active slides but leaves their links/buttons
 * in the tab order, which fails the "ARIA hidden element must not be focusable or contain
 * focusable elements" audit. We mirror aria-hidden with the `inert` attribute so the
 * hidden slide and its descendants are removed from the tab order and accessibility tree.
 */
(function () {
  function syncInert(cell) {
    if (cell.getAttribute('aria-hidden') === 'true') {
      cell.setAttribute('inert', '');
    } else {
      cell.removeAttribute('inert');
    }
  }

  function isCarouselCell(el) {
    return el.parentElement && el.parentElement.classList.contains('flickity-slider');
  }

  function init() {
    document.querySelectorAll('.flickity-slider > [aria-hidden]').forEach(syncInert);

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        var target = mutation.target;
        if (mutation.attributeName === 'aria-hidden' && isCarouselCell(target)) {
          syncInert(target);
        }
      });
    }).observe(document.body, {
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-hidden']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/**
 * Quantity bundle widget (snippets/quantity-bundle.liquid).
 *
 * Lets the visitor pick 1 / 2 / 3 stuks. Selecting a tier sets the product
 * form's quantity and previews the discounted price. The real discount is applied
 * by Shopify automatic discounts at the cart/checkout (10% from 2, 20% from 3).
 */
(function () {
  function formatMoney(cents, format) {
    format = format || (window.theme && window.theme.moneyFormat) || '€{{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;

    function number(precision, thousands, decimal) {
      var amount = (cents / 100).toFixed(precision);
      var parts = amount.split('.');
      var integer = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return integer + (parts[1] ? decimal + parts[1] : '');
    }

    var value;
    var match = format.match(placeholder);
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = number(0, ',', '.'); break;
      case 'amount_with_comma_separator': value = number(2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = number(0, '.', ','); break;
      case 'amount_with_space_separator': value = number(2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = number(0, ' ', ''); break;
      case 'amount_with_apostrophe_separator': value = number(2, "'", '.'); break;
      default: value = number(2, ',', '.');
    }
    return format.replace(placeholder, value);
  }

  function multiAdd(button, items) {
    document.dispatchEvent(new CustomEvent('theme:loading:start'));
    button.setAttribute('disabled', 'disabled');
    var addUrl = (window.routes && window.routes.cartAddUrl) ? window.routes.cartAddUrl : '/cart/add';
    fetch(addUrl + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    }).then(function (response) {
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      button.removeAttribute('disabled');
      if (response.ok) {
        var totalQty = items.reduce(function (s, i) { return s + i.quantity; }, 0);
        // Re-use the theme's own event so the mini-cart refreshes + opens.
        button.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail: { quantity: totalQty, button: button } }));
      } else {
        response.json().then(function (content) {
          window.alert((content && content.description) || 'Kon niet aan winkelwagen toevoegen.');
        });
      }
    });
  }

  function initBundle(bundle) {
    var form = bundle.closest('form');
    var qtyInput = form ? form.querySelector('[name="quantity"]') : null;
    var options = Array.prototype.slice.call(bundle.querySelectorAll('.qty-bundle__option'));
    var unitPrice = parseInt(bundle.getAttribute('data-unit-price'), 10) || 0;
    var comparePrice = parseInt(bundle.getAttribute('data-compare-price'), 10) || 0;
    var addButton = form ? form.querySelector('.product-form__add-button') : null;

    // Mix & match: per-unit variant pickers rendered INSIDE the selected option.
    var data = null;
    try {
      var dataEl = bundle.querySelector('[data-bundle-data]');
      if (dataEl) { data = JSON.parse(dataEl.textContent); }
    } catch (e) { data = null; }
    var enableMix = !!(data && data.variants && data.variants.length > 1 && data.options && data.options.length > 0);

    var state = { qty: 1, discount: 0, opt: null };

    // The mix area lives inside whichever option is currently selected.
    function activeMix() { return state.opt ? state.opt.querySelector('[data-bundle-mix]') : null; }

    // The bundle controls quantity, so hide the theme's standalone quantity picker.
    if (form) {
      var picker = form.querySelector('.product-form__info-item--quantity');
      if (picker) {
        picker.style.display = 'none';
      }
    }

    function findVariant(values) {
      if (!data) { return null; }
      for (var i = 0; i < data.variants.length; i++) {
        var vo = data.variants[i].options;
        var match = vo.length === values.length;
        for (var j = 0; match && j < values.length; j++) {
          if (vo[j] !== values[j]) { match = false; }
        }
        if (match) { return data.variants[i]; }
      }
      return null;
    }

    function getRowVariants() {
      var container = activeMix();
      if (!container) { return []; }
      return Array.prototype.slice.call(container.querySelectorAll('[data-bundle-row]')).map(function (row) {
        var values = Array.prototype.slice.call(row.querySelectorAll('select')).map(function (s) { return s.value; });
        return findVariant(values);
      });
    }

    // Recompute the SELECTED tier total/strike/per from the chosen variants and
    // flag the add button when a chosen combination is unavailable.
    function applyRows() {
      if (!enableMix || !state.opt || state.qty < 2) { return; }
      var container = activeMix();
      if (!container) { return; }
      var rows = container.querySelectorAll('[data-bundle-row]');
      var variants = getRowVariants();
      var priceSum = 0, refSum = 0, ok = true;
      variants.forEach(function (v, idx) {
        var valid = v && v.available;
        if (rows[idx]) { rows[idx].classList.toggle('qty-bundle__mix-row--invalid', !valid); }
        if (valid) {
          priceSum += v.price;
          refSum += (v.compare && v.compare > v.price) ? v.compare : v.price;
        } else {
          ok = false;
          priceSum += unitPrice;
          refSum += comparePrice > unitPrice ? comparePrice : unitPrice;
        }
      });
      var total = Math.round(priceSum * (1 - state.discount));
      var totalEl = state.opt.querySelector('[data-bundle-total]');
      var perEl = state.opt.querySelector('[data-bundle-per]');
      var strikeEl = state.opt.querySelector('[data-bundle-strike]');
      if (totalEl) { totalEl.textContent = formatMoney(total); }
      if (perEl) { perEl.textContent = formatMoney(Math.round(total / state.qty)); }
      if (strikeEl) { strikeEl.textContent = refSum > total ? formatMoney(refSum) : ''; }
      if (addButton) { addButton.classList.toggle('button--disabled', !ok); }
    }

    function renderMix(qty) {
      if (!enableMix) { return; }
      // Clear every option's mix area, then fill only the selected one.
      Array.prototype.slice.call(bundle.querySelectorAll('[data-bundle-mix]')).forEach(function (c) {
        c.innerHTML = '';
        c.hidden = true;
      });
      if (addButton) { addButton.classList.remove('button--disabled'); }
      if (qty < 2) { return; }
      var container = activeMix();
      if (!container) { return; }

      var defaults = data.selected || data.variants[0].options;
      var html = '<p class="qty-bundle__mix-heading">' + data.options.map(function (o) { return o.name; }).join(', ') + '</p>';
      for (var i = 0; i < qty; i++) {
        html += '<div class="qty-bundle__mix-row" data-bundle-row>';
        html += '<span class="qty-bundle__mix-index">#' + (i + 1) + '</span>';
        html += '<div class="qty-bundle__mix-selects">';
        data.options.forEach(function (o, j) {
          html += '<div class="qty-bundle__mix-field"><select class="qty-bundle__mix-select" aria-label="' + o.name + '">';
          o.values.forEach(function (val) {
            var sel = (defaults && defaults[j] === val) ? ' selected' : '';
            html += '<option value="' + String(val).replace(/"/g, '&quot;') + '"' + sel + '>' + val + '</option>';
          });
          html += '</select></div>';
        });
        html += '</div></div>';
      }
      container.innerHTML = html;
      container.hidden = false;
      Array.prototype.slice.call(container.querySelectorAll('select')).forEach(function (s) {
        s.addEventListener('change', applyRows);
      });
      applyRows();
    }

    function render() {
      options.forEach(function (opt) {
        var qty = parseInt(opt.getAttribute('data-qty'), 10);
        var discount = parseInt(opt.getAttribute('data-discount'), 10) / 100;
        var total = Math.round(unitPrice * qty * (1 - discount));
        var per = Math.round(unitPrice * (1 - discount));
        // Strikethrough uses the compare-at ("was") price so the full saving shows.
        var refUnit = comparePrice > unitPrice ? comparePrice : unitPrice;
        var strike = refUnit * qty;

        var totalEl = opt.querySelector('[data-bundle-total]');
        var perEl = opt.querySelector('[data-bundle-per]');
        var strikeEl = opt.querySelector('[data-bundle-strike]');

        if (totalEl) { totalEl.textContent = formatMoney(total); }
        if (perEl) { perEl.textContent = formatMoney(per); }
        if (strikeEl) { strikeEl.textContent = strike > total ? formatMoney(strike) : ''; }
      });
      // The selected tier may be overridden by the chosen mixed variants.
      applyRows();
    }

    function select(opt) {
      var changed = state.opt !== opt;
      options.forEach(function (o) {
        var on = o === opt;
        o.classList.toggle('is-selected', on);
        o.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      state.opt = opt;
      state.qty = parseInt(opt.getAttribute('data-qty'), 10) || 1;
      state.discount = (parseInt(opt.getAttribute('data-discount'), 10) || 0) / 100;
      if (qtyInput) {
        qtyInput.value = state.qty;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      // Only (re)build the rows when the tier actually changes, so re-clicking the
      // already-selected option doesn't wipe the customer's per-unit choices.
      if (changed) { renderMix(state.qty); } else { applyRows(); }
    }

    options.forEach(function (opt) {
      opt.addEventListener('click', function (event) {
        // Clicks inside the per-unit mix area must not re-select (which would reset the rows).
        if (event.target.closest('[data-bundle-mix]')) { return; }
        select(opt);
      });
      opt.addEventListener('keydown', function (event) {
        if (event.target.closest('[data-bundle-mix]')) { return; }
        if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
          event.preventDefault();
          select(opt);
        }
      });
    });

    document.addEventListener('variant:changed', function (event) {
      var variant = event.detail && event.detail.variant;
      if (!variant || typeof variant.price === 'undefined') {
        return;
      }
      unitPrice = variant.price;
      comparePrice = variant.compare_at_price || 0;
      // Keep the per-unit pickers' default in sync with the top selector.
      if (enableMix && variant.options) { data.selected = variant.options; }
      render();
    });

    // When mixing (2+), intercept add-to-cart and add each chosen variant as its own line.
    if (addButton && enableMix) {
      addButton.addEventListener('click', function (event) {
        if (state.qty < 2) { return; } // qty 1 → let the theme add the selected variant normally
        event.preventDefault();
        event.stopPropagation();
        var variants = getRowVariants();
        var items = [];
        var allValid = true;
        variants.forEach(function (v) {
          if (v && v.available) { items.push({ id: v.id, quantity: 1 }); } else { allValid = false; }
        });
        if (!allValid || !items.length) { applyRows(); return; }
        multiAdd(addButton, items);
      });
    }

    render();
    var selected = bundle.querySelector('.qty-bundle__option.is-selected') || options[0];
    if (selected) { select(selected); }
  }

  function initBundles() {
    document.querySelectorAll('[data-qty-bundle]').forEach(initBundle);
  }

  // Keep the price shown inside the add-to-cart button in sync with the
  // selected variant and quantity (the bundle selector drives the quantity).
  function initBuyButtonPrice(btn) {
    var totalEl = btn.querySelector('[data-buy-total]');
    if (!totalEl) { return; }

    var form = btn.closest('form');
    var qtyInput = form ? form.querySelector('[name="quantity"]') : null;
    var unitPrice = parseInt(btn.getAttribute('data-unit-price'), 10) || 0;

    function render() {
      var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
      totalEl.textContent = formatMoney(unitPrice * qty);
    }

    if (qtyInput) {
      qtyInput.addEventListener('change', render);
      qtyInput.addEventListener('input', render);
    }

    document.addEventListener('variant:changed', function (event) {
      var variant = event.detail && event.detail.variant;
      if (!variant || typeof variant.price === 'undefined') { return; }
      unitPrice = variant.price;
      render();
    });

    render();
  }

  function initBuyButtonPrices() {
    document.querySelectorAll('.product-form__add-button[data-unit-price]').forEach(initBuyButtonPrice);
  }

  function initAll() {
    initBundles();
    initBuyButtonPrices();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();

/**
 * Live in-stock pulse.
 * Keeps the product-page stock indicator in sync with the selected variant. The
 * initial state is rendered server-side in product-variant-selector.liquid; here
 * we react to variant:changed and re-derive the state from the per-variant map
 * (which carries the real, server-only inventory_quantity).
 */
(function () {
  'use strict';

  var OUT_TEXT = 'Tijdelijk uitverkocht';
  var IN_TEXT = 'Op voorraad – klaar om te verzenden';

  function apply(el, available, tracked, qty, threshold) {
    var textEl = el.querySelector('[data-stock-pulse-text]');
    el.classList.remove('stock-pulse--low', 'stock-pulse--out');

    if (!available) {
      el.classList.add('stock-pulse--out');
      if (textEl) textEl.textContent = OUT_TEXT;
    } else if (tracked && qty > 0 && qty <= threshold) {
      el.classList.add('stock-pulse--low');
      if (textEl) textEl.textContent = 'Nog ' + qty + ' op voorraad!';
    } else if (textEl) {
      textEl.textContent = IN_TEXT;
    }
  }

  document.addEventListener('variant:changed', function (event) {
    var el = document.querySelector('[data-stock-pulse]');
    if (!el) {
      return;
    }

    var threshold = parseInt(el.getAttribute('data-low-threshold'), 10) || 0;
    var variant = event.detail && event.detail.variant;

    // No selectable variant for the chosen options -> treat as unavailable.
    if (!variant) {
      apply(el, false, false, 0, threshold);
      return;
    }

    var map = {};
    try {
      map = JSON.parse(el.getAttribute('data-stock-map') || '{}');
    } catch (e) {
      map = {};
    }

    var info = map[variant.id];
    var available = info ? info.available : variant.available;
    var tracked = info ? info.tracked : false;
    var qty = info ? info.qty : 0;

    apply(el, available, tracked, qty, threshold);
  });
})();

